import { unlayerDesign } from './UnlayerDesignProcessor';
import { STANDARD_FIELDS } from '@infusionsoft/keap-unlayer-editor';
import {
    KEAP_TOOLS,
    KEAP_TOOLS_FORM_COUNTER_KEY,
    STANDARD_BILLING_POSTAL_CODE_FIELD_ID,
    STANDARD_BIRTHDAY_FIELD_ID,
    STANDARD_COMPANY_FIELD_ID,
    STANDARD_EMAIL1_FIELD_ID,
    STANDARD_FAMILY_NAME_FIELD_ID,
    STANDARD_GIVEN_NAME_FIELD_ID,
    STANDARD_NOTE_FIELD_ID,
    STANDARD_PHONE1_FIELD_ID,
    STANDARD_PHONE1_TYPE_FIELD_ID,
    STANDARD_WEBSITE_FIELD_ID,
} from '../util/marketing/unlayer.constants';

/*
 * Takes in default unlayer form fields from a template, and maps all the names, labels, and options to keap names,
 * while still maintaining the unlayer structure.
 * @param unlayerField
 */
export const renameUnlayerFieldsToKeapFields = (unlayerField) => {
    const { name: fieldName } = unlayerField;

    // Unlayer has a single name field (full name) that needs to be split into two fields for keap
    if (fieldName === 'name') {
        return [
            {
                ...unlayerField,
                name: STANDARD_GIVEN_NAME_FIELD_ID,
                placeholder_text: 'First name',
                label: 'First name',
            },
            {
                ...unlayerField,
                name: STANDARD_FAMILY_NAME_FIELD_ID,
                placeholder_text: 'Last name',
                label: 'Last name',
            },
        ];
    }
    const id = toFieldId(unlayerField);
    const noMatchFound = !id;

    return noMatchFound ? [] : [{
        ...unlayerField,
        name: id,
    }];
};

/**
 * Converts a smartForm/customForm field from definitions in customForm.constants.js
 *
 * @param unlayerField The form field definition from smartForms/publicForms
 */
export const convertFromUnlayerFieldToCustomFormField = (unlayerField) => {
    const { required } = unlayerField;

    const id = toFieldId(unlayerField);

    if (STANDARD_FIELDS.find((def) => def.id === id) || isCustomField(id)) {
        return {
            id,
            fieldType: 'External',
            required,
        };
    }

    return null;
};

function toFieldId({ name }) {
    const mapped = fieldToStandard[name];

    if (!mapped) {
        return name;
    }

    return mapped;
}

function isCustomField(fieldId) {
    return Number.isInteger(Number.parseInt(fieldId, 10));
}

let formCount = 1;

/**
 * Within an unlayer document, converts each form into a keap#form, also making sure to
 * adjust the internal unlayer counters.
 *
 * This also converts all form fields from the unlayer naming convention into keap field names, as defined in
 * customForms.constants.js and in customFields.
 */
export function convertUnlayerFormsToKeapForms(design) {
    const designHelper = unlayerDesign(design);
    const unlayerForms = designHelper.findByType(KEAP_TOOLS.unlayerForm);

    unlayerForms
        .forEach((form, formIndex) => {
            form.content.type = 'custom';
            form.content.slug = KEAP_TOOLS.keapForm;
            form.content.values.fields = form.content.values.fields?.flatMap((fld) => renameUnlayerFieldsToKeapFields(fld));
            form.content.values.keapForm = { slug: `${Date.now()}-${formCount++}` };
            // eslint-disable-next-line no-underscore-dangle
            form.content.values._meta = {
                htmlID: `u_content_custom_${KEAP_TOOLS.keapForm}_${formIndex}`,
                htmlClassNames: `u_content_custom_${KEAP_TOOLS.keapForm}`,
            };
        });

    return {
        ...designHelper.design,
        counters: {
            ...designHelper.design.counters,
            [KEAP_TOOLS_FORM_COUNTER_KEY]: unlayerForms.length,
        },
    };
}

const fieldToStandard = {
    first_name: STANDARD_GIVEN_NAME_FIELD_ID,
    last_name: STANDARD_FAMILY_NAME_FIELD_ID,
    email: STANDARD_EMAIL1_FIELD_ID,
    phone: STANDARD_PHONE1_FIELD_ID,
    phone_number: STANDARD_PHONE1_FIELD_ID,
    phoneType: STANDARD_PHONE1_TYPE_FIELD_ID,
    note: STANDARD_NOTE_FIELD_ID,
    company: STANDARD_COMPANY_FIELD_ID,
    birthday: STANDARD_BIRTHDAY_FIELD_ID,
    website: STANDARD_WEBSITE_FIELD_ID,
    zip_code: STANDARD_BILLING_POSTAL_CODE_FIELD_ID,
};
